function addClassIfActive(divs, className) {
    var clickedButton = $(this);

    clickedButton.find('i').addClass(className);
    clickedButton.addClass('selected');

    divs.each(function () {
        var currentButton = $(this);
        if (!currentButton.is(clickedButton)) {
            currentButton.find('i').removeClass(className);

            if (currentButton.parent().hasClass('accordion-item')) {
                var collapseContent = currentButton.next();
                if (collapseContent.hasClass('show')) {
                    collapseContent.removeClass('show');
                    currentButton.removeClass('selected');
                }
            }
        }
    });
}

$(document).ready(function () {
    // .tabs-featured-solutions
    let tabBtns = $('.tabs-featured-solutions .nav-tabs .nav-link');
    // console.log('tabBtns: ', tabBtns);

    let maxHeightFeaturedSols = 0;
    $('.tabs-featured-solutions .tab-content').each(function () {
        // Get the height of the current tab-pane
        var current_height = $(this).height();

        // Update maxHeightFeaturedSols if current_height is greater
        if (current_height > maxHeightFeaturedSols) {
            maxHeightFeaturedSols = current_height;
        }
        console.log('minH', maxHeightFeaturedSols);
    });
    $('.tabs-featured-solutions').height = maxHeightFeaturedSols;

    tabBtns.on('click keyup', function () {
        addClassIfActive.call(this, tabBtns, 'fa-angle-right');
        $('html, body').animate({
            scrollTop: $('.tabs-featured-solutions .nav-tabs').offset().top - 50,
        });
    });

    let accordionBtns = $('.tabs-featured-solutions .accordion-item .nav-link');
    // console.log('accordionBtns: ', accordionBtns);

    accordionBtns.on('click keyup', function () {
        addClassIfActive.call(this, accordionBtns, 'fa-angle-down');
        var selectedButtons = accordionBtns.filter('.selected');
        if (selectedButtons.length > 0) {
            var lastAccordionBtn = selectedButtons.last();
            lastAccordionBtn.next().addClass('show');
            lastAccordionBtn.addClass('selected');
            // console.log('check');
            $('html, body').animate(
                {
                    scrollTop: $(this).offset().top - 90,
                },
                500,
            );
        }
    });

    // .tabs-accordion
    let tabAccordionBtns = $('.tabs-accordion .nav-tabs .nav-link');
    // console.log('tabAccordionBtns: ', tabAccordionBtns);

    tabAccordionBtns.on('click keyup', function () {
        addClassIfActive.call(this, tabAccordionBtns, 'fa-angle-left');
        $('html, body').animate({
            scrollTop: $('.tabs-accordion .nav-tabs').offset().top - 50,
        });
    });

    let maxHeight = 0;
    $('.tabs-accordion .tab-content').each(function () {
        // Get the height of the current tab-pane
        var current_height = $(this).height();

        // Update maxHeight if current_height is greater
        if (current_height > maxHeight) {
            maxHeight = current_height;
        }
        console.log('minH', maxHeight);
    });
    $('.tabs-accordion').height = maxHeight;

    let tabAccordionBtnsMobile = $('.tabs-accordion .accordion-item .nav-link');
    // console.log('tabAccordionBtnsMobile: ', tabAccordionBtnsMobile);

    tabAccordionBtnsMobile.on('click keyup', function () {
        addClassIfActive.call(this, tabAccordionBtnsMobile, 'fa-angle-down');
        var selectedButtons = tabAccordionBtnsMobile.filter('.selected');
        if (selectedButtons.length > 0) {
            var lastAccordionBtn = selectedButtons.last();
            lastAccordionBtn.next().addClass('show');
            lastAccordionBtn.addClass('selected');
            // console.log('check');
            $('html, body').animate(
                {
                    scrollTop: $(this).offset().top - 90,
                },
                500,
            );
        }
    });
});
